import { useEffect, useRef, useState } from 'react';

// -------------------------------
// Subcomponent: FilterDropdown
// Reusable filter component for centers/patients
// -------------------------------
export const FilterDropdown = ({ label, count, options, selectedItems, onToggle, loading, error, disabled, style }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="dropdown-container" ref={dropdownRef} style={style}>
            <button
                className="dropdown-trigger"
                onClick={() => setIsOpen(!isOpen)}
                disabled={disabled || loading}
            >
                {label} ({count})
            </button>
            {isOpen && (
                <div className="dropdown-content">
                    {loading && <div className="dropdown-loading">Loading...</div>}
                    {error && <div className="dropdown-error">Error: {error}</div>}
                    {!loading && !error && options.length === 0 && (
                        <div className="dropdown-empty">No {label.toLowerCase()} available</div>
                    )}
                    {!loading && !error && options.map(option => (
                        <label key={option.id} className="dropdown-item">
                            <input
                                type="checkbox"
                                checked={selectedItems.includes(option.id)}
                                onChange={() => onToggle?.(option.id)}
                            />
                            <span>
                                {option.name || option.label}
                            </span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};
